import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--delete" icon='delete'>{ children ? children : 'Delete' }</Button>
}